export const API_CONFIG = {
  baseURL: process.env.REACT_APP_BACKEND_URL || "http://localhost:8000/"
};